import Button from "../../Button";
import React, {
  useContext,
  useMemo,
  useEffect,
  useRef,
  useState,
} from "react";
import constants, {
  complexityid,
  libTypeIds,
  QUESTION_BASED_TYPES,
  RESULT_STATUS,
} from "../../../constants";
import { getDataFromStorage, isGradiousAdmin } from "../../../util";
import Search from "../../CommonComponents/Search";
import UploadSvg from "../../../Svg/UploadIconsvg";
import UploadQns from "../QuestionEntry/UploadQns";
// import TestSvgIcon from "../../../Svg/TestSvgIcon";
import AlertContext from "../../../context/AlertContext";
import {
  Link,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import InputDropdown, { DropdownMenu } from "../../CommonComponents/InputDropdown";
import { LibraryContext } from "../../../context/LibraryContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import Modal from "../../CommonComponents/Modal";
import InputField from "../../CommonComponents/InputField";
import useAuth from "../../../Hooks/useAuth";
import TestSvgIcon from "../../../Svg/TestSvgIcon";
import IconButton from "../../CommonComponents/IconButton";
import Tooltip from "../../CommonComponents/Tooltip";
export const libTypeName = {
  2: "MCQ",
  11: "SQL",
  3: "Descriptive",
  1: "Content",
  4: "Assignment",
  5: "Coding Challenge",
  12: "Coding Snippet",
};

const sharedScopeOptions = [
  { label: "All", value: "all" },
  { label: "Public", value: constants.SHARED_SCOPE.PUBLIC },
  { label: "Private", value: constants.SHARED_SCOPE.PRIVATE },
  { label: "Specific", value: constants.SHARED_SCOPE.SPECIFIC },
];

const difficultyOptions = [
  { label: "All", value: "" },
  { label: "Easy", value: complexityid.EASY },
  { label: "Medium", value: complexityid.MEDIUM },
  { label: "Hard", value: complexityid.HARD },
];

const LibraryUtils = ({ onSearch, onAdd, onTopicSelect, que }) => {
  const {
    navigate,
    setShowNotify,
    setCurrentPage,
    setIsCodingChallenge,
  } = useContext(AlertContext);
  const {
    setSelectedTopic,
    setSearchText,
    setSharedTopics,
    setFilterSharedTopics,
    searchText,
    topics,
    selectedScope,
    setSelectedScope,
    setTopics,
    ccTestData,
    setCcTestData,
    editCodingCategories,
    setEditCodingCategories,
    setOpenQuestionModal,
    addSectionModal,
    setAddSectionModal,
  } = useContext(LibraryContext);

  const axios = useAxiosPrivate();
  const { type, secid } = useParams();
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const selectable = searchParams.get("selectable") === "true" || false;
  const lpId = searchParams.get("lpId") || null;
  const moduleId = searchParams.get("moduleId") || null;
  const chapterId = searchParams.get("chapterId") || null;
  const batchId = searchParams.get("bId") || null;
  const baseRoute = batchId ? `/batches/${batchId}/courses` : "/learningpath";
  const subId = searchParams.get("subId") || null;
  const topId = searchParams.getAll("topId") || null;
  const selectedDifficulty = searchParams.get("complexityid") || "";
  const isVideoInterview =
    searchParams.get("isVideoInterview") === "true" || false;
  const isAiInterivew = searchParams.get("isAiInterview") === "true" || false;
  // console.log("topId", topId);

  let queryString = `${selectable
    ? `?selectable=${selectable}${lpId ? `&lpId=${lpId}` : ""}${moduleId ? `&moduleId=${moduleId}` : ""
    }${chapterId ? `&chapterId=${chapterId}` : ""}${batchId ? `&bId=${batchId}` : ""
    }`
    : ""
    }`;
  const isSubjectPage = pathname.includes("/subjects");
  const isQuestionPage = pathname.includes("/questionlist");
  const isSharedPage = pathname.includes("/shared");
  const isTestListPage = pathname.includes("/testlist");
  const codingCategoriesPage = pathname.includes("/section");

  const searchPlaceHolder = +topId
    ? "Search Question"
    : +subId
      ? "Search Topic"
      : isSubjectPage
        ? "Search Subject"
        : "Search";

  const buttonText = +topId
    ? "Question"
    : +subId
      ? "Topic"
      : isSubjectPage
        ? "Subject"
        : +type === libTypeIds.CODING_CHALLENGE && codingCategoriesPage
          ? "Section"
          : isTestListPage
            ? +type === libTypeIds.ASSIGNMENT
              ? "Assignment"
              : +type === libTypeIds.CONTENT
                ? "Content"
                : "Test"
            : isQuestionPage && selectable
              ? ""
              : +type === libTypeIds.ASSIGNMENT
                ? "Assignment"
                : +type === libTypeIds.CONTENT
                  ? "Content"
                  : "Question";

  const contentOrAssignment = [
    constants.libTypeIds.ASSIGNMENT,
    constants.libTypeIds.CONTENT,
  ];

  const [openSubModal, setOpenSubModal] = useState(false);
  const [isDifficultyOpen, setIsDifficultyOpen] = useState(false);
  const difficultyAnchorRef = useRef(null);
  const difficultyDropdownId = "library-difficulty-dropdown";

  const [isLoading, setIsLoading] = useState(false);
  const isMcq = +type === libTypeIds.MCQ;

  useEffect(() => {
    const controller = new AbortController();
    const fetchSubjectTopics = async () => {
      console.log("types for testing", type);
      try {
        const url = isMcq
          ? `node/subject/topics?type=${type}`
          : `node/topic?type=${type}`;
        const { data } = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
          },
          signal: controller.signal,
        });
        if (data.resultCode === RESULT_STATUS.SUCCESS) {
          console.log("data", data.data);

          let transformData = isMcq
            ? data.data.map((sub) => {
              return {
                label: sub.sname,
                value: sub.sid,
                children: sub.topics?.map((top) => {
                  return {
                    label: top.tname,
                    value: top.tid,
                  };
                }),
              };
            })
            : data.data.map((top) => ({
              label: top.name,
              value: top.id,
            })) || [];
          transformData.unshift({ label: "All", value: "" });
          setTopics(transformData);
          console.log("transformData for testing", transformData);
        } else throw new Error("Unable to fetch all subjects and topics");
      } catch (error) {
        let isUnAuth = error?.response?.status === 403;
        if (error?.name === "CanceledError" || error?.name === "AbortError")
          return;
        setShowNotify({
          show: true,
          msg: isUnAuth
            ? "You have been logged-out due to inactivity. Login again."
            : "Unable to fetch all subjects and topics. Please try again later",
          title: isUnAuth ? "Warning !" : "Error !",
          isUnAuth,
        });
      }
    };
    !isTestListPage && !isSubjectPage && !isSharedPage && fetchSubjectTopics();
    return () => controller.abort();
  }, [axios, setShowNotify, pathname, type, setTopics, isMcq, isTestListPage]);

  const onChange = (event) => {
    if (onSearch) onSearch(event);
    setCurrentPage(1);
    setSearchText(event.target.value);
  };

  const handleOnChangeTopic = (value) => {

    if (onTopicSelect) onTopicSelect(value);
    setCurrentPage(1);
    // setSelectedTopic(value);
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);

      params.delete("topId");

      if (Array.isArray(value)) {
        value.forEach((id) => {
          params.append("topId", id);
        });
      } else if (value) {
        params.append("topId", value);
      }

      return params;
    });
  };

  const handleDifficultyChange = (value) => {
    setCurrentPage(1);
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);

      if (value) {
        params.set("complexityid", value);
      } else {
        params.delete("complexityid");
      }

      return params;
    });
    setIsDifficultyOpen(false);
  };

  // console.log("selectedTopic:", selectedTopic)

  const clearState = () => {
    setSharedTopics([]);
    setFilterSharedTopics([]);
    setSelectedTopic(null);
    setSearchText("");
    setCurrentPage(1);
  };

  const handleUploadFbfile = (libTypeId) => (e) => {
    setShowNotify({
      show: true,
      size: "md",
      showClose: true,
      hideButton: true,
      title: "UPLOAD & ADD QUESTIONS",
      msg: <UploadQns libType={libTypeId} />,
    });
  };

  const handleBacktoLp = () => {
    setIsCodingChallenge(false);
    setCcTestData({ ccWithFixedQn: false, qnId: null, topicId: null });
    navigate(`${baseRoute}/${lpId}/module/${moduleId}?chapterId=${chapterId}`);
  };

  const companyId = parseInt(getDataFromStorage("companyId"));
  const GradiousAdmin = useMemo(() => isGradiousAdmin(), []);
  const hasTestAccess = useMemo(
    () =>
      getDataFromStorage("role") !== constants.Roles.hr &&
      getDataFromStorage("role") !== constants.Roles.customer &&
      getDataFromStorage("role") !== constants.Roles.tutor &&
      getDataFromStorage("role") !== constants.Roles.creator,
    [],
  );

  const testType = [
    "",
    "Content",
    "MCQS",
    "Descriptive",
    "Assignment",
    "Coding Challenge",
    "SAQ",
    "LAQ",
    "MCQ_SINGLE",
    "MCQ_MULTI",
    "LEARNINGPATH",
    "SQL",
    "Coding Snippet",
    "Video Test",
    "Ai Interview"
  ];


  const tabs = useMemo(
    () => [
      {
        id: 1,
        label:
          companyId === constants.GRADIOUS_ACCOUNT_ID ? "Shared" : "Gradious",

        className: "libdTab",
        link: `/library/${type}/shared`,
      },

      ...(QUESTION_BASED_TYPES.includes(Number(type)) && hasTestAccess
        ? [
          {
            id: 2,
            // label: isAiInterivew
            //   ? testType[14]
            //   : isVideoInterview
            //     ? testType[13]
            //     : testType[type],
            label: "Tests",
            className: "libdTests",
            link: `/library/${type}/testlist`,
          },
        ]
        : []),
      ...(Number(type) === libTypeIds.MCQ
        ? [
          {
            id: 3,
            label: "Subjects",

            className: "libdSubjects",
            link: `/library/${type}/subjects`,
          },
        ]
        : []),


      {
        id: 4,
        label: `My ${parseInt(type) === constants.libTypeIds.CONTENT
          ? "Content"
          : parseInt(type) === constants.libTypeIds.ASSIGNMENT
            ? "Assignments"
            : "Questions"
          }`,

        className: "libdMyQuesContainer",
        link: `/library/${type}/questionlist`,
      },

      ((Number(type) === libTypeIds.CODING_CHALLENGE && companyId === constants.GRADIOUS_ACCOUNT_ID) ? {
        id: 5,
        label: `Coding Categories`,
        className: "libdCodingCategories",
        link: `/library/${type}/cc/section`,
      } : []
      )

    ],
    [companyId, type, hasTestAccess, isAiInterivew, isVideoInterview],
  );

  const onClickAdd = async () => {
    console.log("isQuestion:", isQuestionPage, isTestListPage);

    if (isQuestionPage) {
      const params = new URLSearchParams(searchParams);
      if (selectable) {
        if (!ccTestData.qnId) {
          setShowNotify({
            title: "Warning !",
            msg: `Please the question to add as test`,
            show: true,
          });
          return;
        }
        const { data: testRes } = await axios.post(
          "node/admin/test/create",
          ccTestData,
        );
        if (testRes.resultCode === RESULT_STATUS.SUCCESS) {
          if (lpId) {
            let tests = [testRes.data.testId];
            const { data } = await axios.post(
              `node/admin/learningpath/${lpId}/module/${moduleId}/assign-tests`,
              { type: type, tests, chapterId },
            );

            if (data.resultCode === RESULT_STATUS.SUCCESS) {
              navigate(
                `${baseRoute}/${lpId}/module/${moduleId}?chapterId=${chapterId}`,
              );
            } else {
              navigate(`/library/${type}/testlist${queryString}`);
              throw new Error(
                `The test is created but unable to assigned to the path`,
              );
            }
          }
        } else {
          setShowNotify({
            title: "Warning !",
            msg:
              testRes?.msg ??
              `Unable to create the test. Please try again later`,
            show: true,
          });
        }
      } else if (parseInt(type) === constants.libTypeIds.CONTENT) {
        navigate(`/library/${type}/contententry`);
      } else if (parseInt(type) === constants.libTypeIds.ASSIGNMENT)
        navigate(`/library/${type}/assignment`);
      else {
        navigate({ pathname: `/library/${type}/questions`, search: params.toString() });
      }

      // que({ published: 0 ,type:type});  //check before commit
    }
    if (isTestListPage) {
      const params = new URLSearchParams(searchParams);
      if (+type === libTypeIds.CONTENT) {
        navigate({
          pathname: `/library/${type}/contententry`,
          search: params.toString(),
        });
      }
      else if (+type === libTypeIds.ASSIGNMENT) {
        navigate({
          pathname: `/library/${type}/assignment`,
          search: params.toString(),
        });
      }
      else {
        navigate({
          pathname: `/library/${type}/test/create`,
          search: params.toString(),
        });
      }
    }
    if (+subId && +topId) {
      const params = new URLSearchParams(searchParams);
      if (parseInt(type) === constants.libTypeIds.CONTENT) {
        navigate(`/library/${type}/contententry`);
      } else if (parseInt(type) === constants.libTypeIds.ASSIGNMENT)
        navigate(`/library/${type}/assignment`);
      else {
        navigate({ pathname: `/library/${type}/questions`, search: params.toString() });
      }
    }
    if (isSubjectPage) setOpenSubModal(true);
    if (codingCategoriesPage) setAddSectionModal(true);
  };

  return (
    <div className="libdTabsAndUtilsContainter">
      {!contentOrAssignment.includes(parseInt(type)) && !selectable ? (
        <div className="libdTabs">
          {tabs.map((tab) => (
            <Link
              key={tab.id}
              onClick={() => clearState()}
              to={`${tab.link}${isVideoInterview
                ? "?isVideoInterview=true"
                : isAiInterivew
                  ? "?isAiInterview=true"
                  : ""
                }`}
              className={`libdTab ${pathname.startsWith(tab.link) ? "active" : ""
                } ${tab.className}`}
            >
              {tab.label}
            </Link>
          ))}
        </div>
      ) : selectable ? (
        <>
          <div
            onClick={handleBacktoLp}
            className="libdcTitle car"
            style={{ padding: "9px 9px", cursor: "pointer" }}
          >
            <FontAwesomeIcon
              icon={faArrowLeft}
            // className="adminTestBackBtn"
            // onClick={handleBacktoLp}
            />
          </div>
          <div className="libdTitle car" style={{ padding: "11px 16px" }}>
            {
              +type === libTypeIds.DESCRIPTIVE
                ? isAiInterivew == true
                  ? <TestSvgIcon
                    active={true}
                    disable={false}
                    libType={constants.libTypeIds.DESCRIPTIVE}
                    aiInterview={true}
                  />
                  : isVideoInterview == true ?
                    <TestSvgIcon
                      active={true}
                      disable={false}
                      libType={constants.libTypeIds.DESCRIPTIVE}
                      videoQn={true}
                    />
                    : <TestSvgIcon active={true} disable={false} libType={parseInt(type)} />
                : <TestSvgIcon active={true} disable={false} libType={parseInt(type)} />
            }
            {+type === libTypeIds.DESCRIPTIVE
              ?
              isAiInterivew == true
                ? "AI interview"
                : isVideoInterview == true ?
                  "Video Test"
                  : libTypeName[type]
              : libTypeName[type]}
          </div>
        </>
      ) : (
        // <></>
        <div className="libdTitle car" style={{ padding: "10px 16px" }}>
          <TestSvgIcon active={true} disable={false} libType={parseInt(type)} />
          {libTypeName[type]}
        </div>
      )}
      <div
        className="libdUtils"
        style={
          contentOrAssignment.includes(+type)
            ? { justifyContent: "flex-end", flex: 1, marginBottom: "10px" }
            : { justifyContent: "flex-end", flex: 1, marginBottom: "10px" }
        }
      >
        {isQuestionPage && !contentOrAssignment.includes(+type) && (
          <>
            <Tooltip title="Level Filter" placement="top" maxChars={16}>
              <div className="ccTitleActions" ref={difficultyAnchorRef}>
                <IconButton
                  size="sm"
                  hierarchy="tertiaryGrey"
                  destructive={false}
                  onClick={() => setIsDifficultyOpen((prev) => !prev)}
                >
                  <svg
                    width="20"
                    height="20"
                    fill="none"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 10H15M2.5 5H17.5M7.5 15H12.5"
                      stroke="#667085"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </IconButton>
              </div>
            </Tooltip>
            <div>
              {isDifficultyOpen && (
                <DropdownMenu
                  placement="bottom-start"
                  className="ccHomeSortDropdown"
                  style={{
                    width: Math.max(
                      difficultyAnchorRef.current?.getBoundingClientRect()
                        .width || 0,
                      220,
                    ),
                  }}
                  open={isDifficultyOpen}
                  anchorRef={difficultyAnchorRef}
                  dropdownId={difficultyDropdownId}
                  options={difficultyOptions}
                  value={selectedDifficulty ? +selectedDifficulty : ""}
                  multiple={false}
                  onSelectOption={handleDifficultyChange}
                  onClose={() => setIsDifficultyOpen(false)}
                />
              )}
            </div>
          </>
        )}
        {
          secid && (
            <div className="libdUtils-cc">
              <Tooltip
                title="Edit"
                placement="left-start"
                theme="light"
              >
                <IconButton
                  size="sm"
                  hierarchy="tertiaryGrey"
                  destructive={false}
                  onClick={() => {
                    setEditCodingCategories(true);
                  }}
                >
                  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.5 2.76777H2.66667C2.22464 2.76777 1.80072 2.94336 1.48816 3.25592C1.17559 3.56848 1 3.99241 1 4.43443V16.1011C1 16.5431 1.17559 16.9671 1.48816 17.2796C1.80072 17.5922 2.22464 17.7678 2.66667 17.7678H14.3333C14.7754 17.7678 15.1993 17.5922 15.5118 17.2796C15.8244 16.9671 16 16.5431 16 16.1011V10.2678M14.75 1.51777C15.0815 1.18625 15.5312 1 16 1C16.4688 1 16.9185 1.18625 17.25 1.51777C17.5815 1.84929 17.7678 2.29893 17.7678 2.76777C17.7678 3.23661 17.5815 3.68625 17.25 4.01777L9.33333 11.9344L6 12.7678L6.83333 9.43443L14.75 1.51777Z" stroke="#344054" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </IconButton>
              </Tooltip>

              <Tooltip
              title="Assign"
              placement="right-end"
              theme="light"
              >
                <IconButton
                  size="sm"
                  hierarchy="tertiaryGrey"
                  destructive={false}
                  onClick={() => {
                    setOpenQuestionModal(true);
                  }}
                >
                  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.33333 11.8333L6 13.5L9.75 9.75M6 6V3.66667C6 2.73325 6 2.26654 6.18166 1.91002C6.34144 1.59641 6.59641 1.34144 6.91002 1.18166C7.26654 1 7.73325 1 8.66667 1H15C15.9334 1 16.4001 1 16.7567 1.18166C17.0703 1.34144 17.3252 1.59641 17.485 1.91002C17.6667 2.26654 17.6667 2.73325 17.6667 3.66667V10C17.6667 10.9334 17.6667 11.4001 17.485 11.7567C17.3252 12.0703 17.0703 12.3252 16.7567 12.485C16.4001 12.6667 15.9334 12.6667 15 12.6667H12.6667M3.66667 17.6667H10C10.9334 17.6667 11.4001 17.6667 11.7567 17.485C12.0703 17.3252 12.3252 17.0703 12.485 16.7567C12.6667 16.4001 12.6667 15.9334 12.6667 15V8.66667C12.6667 7.73325 12.6667 7.26654 12.485 6.91002C12.3252 6.59641 12.0703 6.34144 11.7567 6.18166C11.4001 6 10.9334 6 10 6H3.66667C2.73325 6 2.26654 6 1.91002 6.18166C1.59641 6.34144 1.34144 6.59641 1.18166 6.91002C1 7.26654 1 7.73325 1 8.66667V15C1 15.9334 1 16.4001 1.18166 16.7567C1.34144 17.0703 1.59641 17.3252 1.91002 17.485C2.26654 17.6667 2.73325 17.6667 3.66667 17.6667Z" stroke="#344054" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>

                </IconButton>
              </Tooltip>
            </div>
          )
        }
        <Search
          iconPosition="end"
          onChange={onChange}
          value={searchText}
          height="32px"
          placeholder={searchPlaceHolder}
        />
        {(isQuestionPage || isTestListPage) && (
          <InputDropdown
            type="default"
            placeholder="Choose Topics"
            options={topics}
            searchable
            multiple={isTestListPage}
            onChange={handleOnChangeTopic}
            childrenPlacement="left"
            childrenSearch={true}
            value={
              isTestListPage
                ? (topId || []).map((value) => +value)
                : +topId[0] || ""
            }
          />
        )}
        {getDataFromStorage("role") !== constants.Roles.tutor &&
          !isSharedPage && (!codingCategoriesPage || (codingCategoriesPage && !secid)) && (
            <>
              <Button
                size="sm"
                hierarchy={{ type: "primary", buttonText: `Add ${buttonText}` }}
                className="library-add-btn"
                icon={{
                  icon: (
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 1V15M1 8H15"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ),
                  type: "leading",
                }}
                onClick={onClickAdd}
              />
              {[
                libTypeIds.MCQ,
                libTypeIds.SQL,
                libTypeIds.DESCRIPTIVE,
              ].includes(parseInt(type)) &&
                isQuestionPage && (
                  <Button
                    size={"sm"}
                    disable={false}
                    className="library-upload-btn"
                    onClick={handleUploadFbfile(parseInt(type))}
                    icon={{
                      type: "leading",
                      icon: <UploadSvg stroke="#344054" />,
                    }}
                    hierarchy={{
                      type: "secondaryGrey",
                      buttonText: "UPLOAD",
                    }}
                  ></Button>
                )}
            </>
          )}

        {pathname === `/library/${type}/shared` && ((subId) || type != libTypeIds.MCQ) && GradiousAdmin && (
          <InputDropdown
            type="default"
            placeholder="Shared Scope"
            options={sharedScopeOptions}
            searchable
            onChange={setSelectedScope}
            value={selectedScope}
          />
        )}
      </div>
      <Modal
        isOpen={openSubModal}
        onClose={() => setOpenSubModal(false)}
        className="library-add-subject-modal"
        showCloseIcon={false}
      >
        {subId ? (
          <AddTopic setOpenSubModal={setOpenSubModal} isLoading={isLoading} setIsLoading={setIsLoading} />
        ) : (
          <AddSubject setOpenSubModal={setOpenSubModal} setIsLoading={setIsLoading} isLoading={isLoading} />
        )}
      </Modal>
    </div>
  );
};

export default LibraryUtils;

export const AddTopic = ({ setOpenSubModal, isEdit = false, item = null, isLoading, setIsLoading }) => {
  const axios = useAxiosPrivate();
  const { setShowNotify } = useAuth();
  const { setTopics, topics } = useContext(LibraryContext);
  const { type } = useParams();
  const [searchParams] = useSearchParams();
  const subId = searchParams.get("subId") || null;
  const validators = useMemo(
    () => ({
      name: (v) =>
        !v?.trim()
          ? "Enter the topic name"
          : v?.trim()?.lenght > 100
            ? "Max character: 100"
            : "",
      // topName: (v) =>
      //   !v?.trim()
      //     ? "Enter the topic name"
      //     : v?.trim()?.lenght > 100
      //     ? "Max character: 100"
      //     : "",
    }),
    [],
  );
  const [subjects, setSubjects] = useState([]);
  const [formDetails, setFormDetails] = useState({
    name: "",
    subId: +subId,
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (isEdit) {
      setFormDetails((pre) => ({
        ...pre,
        name: item.tname || "",
      }));
    }
  }, [item, isEdit]);
  useEffect(() => {
    const controller = new AbortController();
    const fetchSubjects = async () => {
      try {
        const { data } = await axios.get(`node/subject?type=${type}`, {
          headers: {
            "Content-Type": "application/json",
          },
          signal: controller.signal,
        });
        if (data.resultCode === RESULT_STATUS.SUCCESS) {
          setSubjects(
            data.data.map((sub) => ({ label: sub.name, value: sub.id })),
          );
        }
      } catch (error) {
        console.log("error", error);

        let isUnAuth = error?.response?.status === 403;
        if (error?.name === "CanceledError" || error?.name === "AbortError")
          return;
        setShowNotify({
          show: true,
          msg: isUnAuth
            ? "You have been logged-out due to inactivity. Login again."
            : "Unable to get subjects. Please try again later",
          title: isUnAuth ? "Warning !" : "Error !",
          isUnAuth,
        });
      }
    };
    fetchSubjects();
    return () => controller.abort();
  }, [axios, setShowNotify, type]);

  const onChange = (event) => {
    const error = validators[event.target.name]?.(event.target.value) || "";
    console.log("error", error);

    setErrors((pre) => ({ ...pre, [event.target.name]: error }));
    setFormDetails((pre) => ({
      ...pre,
      [event.target.name]: event.target.value,
    }));
  };
  const onClickCreateOrUpdate = async (event) => {
    setIsLoading(true);
    event.preventDefault();
    try {
      let errors = {};
      Object.entries(formDetails).forEach(([key, value]) => {
        let error = validators[key]?.(value) || "";
        if (error) errors[key] = error;
      });
      if (Object.keys(errors).length > 0) {
        setErrors(errors);
        return;
      }
      const method = isEdit ? "put" : "post";
      const url = isEdit ? `node/topic/${item.tid}` : `node/topic`;
      const { data } = await axios[method](
        url,
        {
          name: formDetails.name,
          subject_id: formDetails.subId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (data.resultCode === RESULT_STATUS.SUCCESS) {
        setShowNotify({
          show: true,
          msg: data.msg,
          title: "Success",
        });
        setOpenSubModal(false);
        if (isEdit) {
          if (subId == formDetails.subId) {
            setTopics((prev) => prev.map((t) => {
              return (
                t.tid == item.tid ? { ...t, tname: formDetails.name } : t
              )
            }));
          }
          else {
            setTopics((prev) => prev.filter((p) => p.tid !== item.tid));
          }
        }
        else {
          setTopics((prev) => [...prev, {
            easy_count: 0,
            hard_count: 0,
            medium_count: 0,
            share_scope: "PRIVATE",
            tid: data.id,
            tname: formDetails.name,
            total_count: 0
          }])
        }
      } else throw new Error(data.msg);
    } catch (error) {
      console.log("error", error);

      let isUnAuth = error?.response?.status === 403;
      if (error?.name === "CanceledError" || error?.name === "AbortError")
        return;
      setShowNotify({
        show: true,
        msg: isUnAuth
          ? "You have been logged-out due to inactivity. Login again."
          : `Unable to ${isEdit ? "update" : "create"
          } topic. Please try again later`,
        title: isUnAuth ? "Warning !" : "Error !",
        isUnAuth,
      });
    }
    finally {
      setIsLoading(false);
    }
  };

  return (
    <form
      className="library-subject-add-form"
      onSubmit={(event) => event.preventDefault()}
    >
      <InputField
        name="name"
        className="library-subject-name-field"
        label="Topic name"
        placeholder="Enter the Topic name"
        value={formDetails.name}
        onChange={onChange}
        hintText={errors.name}
        destructive={!!errors.name}
      />
      <InputDropdown
        label="Select the subject"
        options={subjects}
        placeholder="Select Subject"
        value={formDetails.subId}
        onChange={(value) => onChange({ target: { name: "subId", value } })}
      />
      {/* {isEdit ? (
        <InputField
          name="topName"
          className="library-topic-name-field"
          label="Rename the Topic"
          placeholder="Enter new name"
          value={formDetails.topName}
          onChange={onChange}
          hintText={errors.topName}
          destructive={!!errors.topName}
        />
      ) : null} */}
      <div className="library-subject-add-form-btn-container">
        <Button
          size="sm"
          hierarchy={{ type: "secondaryGrey", buttonText: "Cancel" }}
          onClick={() => setOpenSubModal(false)}
        />
        <Button
          size="sm"
          hierarchy={{
            type: "primary",
            buttonText: `${isEdit ? "Update" : "Create"}`,
          }}
          onClick={onClickCreateOrUpdate}
          disable={!!errors.name || isLoading}
        />
      </div>
    </form>
  );
};

const AddSubject = ({ setOpenSubModal, isLoading, setIsLoading }) => {
  const axios = useAxiosPrivate();
  const { setShowNotify } = useAuth();
  const { setSubjects } = useContext(LibraryContext);
  const validators = useMemo(
    () => ({
      name: (v) =>
        !v?.trim()
          ? "Enter the subject name"
          : v?.trim()?.lenght > 100
            ? "Max character: 100"
            : "",
      // topName: (v) =>
      //   !v?.trim()
      //     ? "Enter the topic name"
      //     : v?.trim()?.lenght > 100
      //     ? "Max character: 100"
      //     : "",
    }),
    [],
  );
  const [formDetails, setFormDetails] = useState({
    name: "",
  });
  const [errors, setErrors] = useState({});
  const onChange = (event) => {
    const error = validators[event.target.name]?.(event.target.value) || "";
    console.log("error", error);

    setErrors((pre) => ({ ...pre, [event.target.name]: error }));
    setFormDetails((pre) => ({
      ...pre,
      [event.target.name]: event.target.value,
    }));
  };
  const onClickCreate = async (event) => {
    event.preventDefault();
    try {
      setIsLoading(true);
      let errors = {};
      Object.entries(formDetails).forEach(([key, value]) => {
        let error = validators[key]?.(value) || "";
        if (error) errors[key] = error;
      });
      if (Object.keys(errors).length > 0) {
        setErrors(errors);
        return;
      }
      const { data } = await axios.post(
        "node/subject",
        {
          name: formDetails.name,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (data.resultCode === RESULT_STATUS.SUCCESS) {
        setShowNotify({
          show: true,
          msg: data.msg,
          title: "Success",
        });
        setOpenSubModal(false);
        setSubjects((prev) => [
          ...prev,
          {
            id: data.id,
            name: formDetails.name,
            easy_count: 0,
            medium_count: 0,
            hard_count: 0,
            total_count: 0,
          },
        ]);
      } else throw new Error(data.msg);
    } catch (error) {
      console.log("error", error);

      let isUnAuth = error?.response?.status === 403;
      if (error?.name === "CanceledError" || error?.name === "AbortError")
        return;
      setShowNotify({
        show: true,
        msg: isUnAuth
          ? "You have been logged-out due to inactivity. Login again."
          : "Unable to create subject. Please try again later",
        title: isUnAuth ? "Warning !" : "Error !",
        isUnAuth,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form
      className="library-subject-add-form"
      onSubmit={(event) => event.preventDefault()}
    >
      <InputField
        name="name"
        className="library-subject-name-field"
        label="Subject name"
        placeholder="Enter the subject name"
        value={formDetails.name}
        onChange={onChange}
        hintText={errors.name}
        destructive={!!errors.name}
      />
      {/* <InputField
        name="topName"
        className="library-topic-name-field"
        label="Topic name"
        placeholder="Enter the topic name"
        value={formDetails.topName}
        onChange={onChange}
        hintText={errors.topName}
        destructive={!!errors.topName}
      /> */}
      <div className="library-subject-add-form-btn-container">
        <Button
          size="sm"
          hierarchy={{ type: "secondaryGrey", buttonText: "Cancel" }}
          onClick={() => setOpenSubModal(false)}
        />
        <Button
          size="sm"
          hierarchy={{ type: "primary", buttonText: "Create" }}
          onClick={onClickCreate}
          disable={!!errors.name || isLoading}
        />
      </div>
    </form>
  );
};
